import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FilterService } from '../../../../../common/services/Filter.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { ReportCustomConst } from './custom.const';
import { Observable } from 'rxjs/Rx';
import { GroupService } from 'app/common/services/Group.service';
import { FieldService } from 'app/common/services/Field.service';
import { TicketService } from 'app/common/services/Ticket.service';
import { OrganizeService } from 'app/common/services/Organize.service';
import { UserService } from 'app/common/services/User.service';
import { SearchService } from 'app/common/services/Search.service';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { Role } from '../../setting/expert/agent/agent.const';
declare var require: any;
const moment = require('moment');

declare var $: any;
@Component({
  selector: 'report-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.css'],
  providers: [FilterService, GroupService, FieldService, TicketService, OrganizeService, UserService, SearchService],
})
export class CustomComponent extends BaseListComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public Role = Role;
  public ngModelData: any = {};
  public exportFields: any[] = [];
  public dataReportCustom: any[] = [];
  public displayTypes: any = {
    View: 'view',
    Edit: 'edit',
    Add: 'add',
  };
  public optionViews: any = {
    reportForm: [{ value: 'excel', label: 'Dạng Excel' }],
    source_detail: [
      { value: '-1', label: 'Chọn nguồn ticket' },
      { value: 'hand', label: 'Thêm mới' },
      { value: 'call_inbound', label: 'Khách gọi tới' },
      { value: 'call_outbound', label: 'Gọi điện ra' },
      { value: 'chat', label: 'Chat' },
      { value: 'email', label: 'Kênh Email' },
      { value: 'facebook', label: 'Kênh Facebook' },
      { value: 'zalo', label: 'Zalo' },
    ],
    typeTimeOption: [
      { value: '', label: 'Chọn loại thời gian' },
      { value: 'time_start', label: 'Thời gian bắt đầu' },
      { value: 'time_end', label: 'Thời gian kết thúc' },
      { value: 'created_at', label: 'Ngày tạo' },
      { value: 'updated_at', label: 'Ngày cập nhật' },
    ],
    currentDatas: {},
  };
  public displayType: any = this.displayTypes.View;
  public isLoading: boolean = true;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private filterService: FilterService,
    private groupService: GroupService,
    private fieldService: FieldService,
    private ticketService: TicketService,
    private organizeService: OrganizeService,
    private userService: UserService,
    private searchService: SearchService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    this.displayColumns = ReportCustomConst.displayColumns();
    this.isLoading = true;
    const allUserPayload: any = {};
    if (this.user.role === Role.TeamLeader) {
      allUserPayload.group_id = this.user.group_id;
    }
    Observable.forkJoin([
      this.ticketService.status(),
      this.groupService.allGroup({ target: 'end_user' }),
      this.groupService.allGroup({ target: 'user' }),
      this.fieldService.allField({ target: 'ticket' }),
      this.userService.all(allUserPayload),
      this.organizeService.allOrganize(),
    ]).subscribe(data => {
      this.getGroupEndUser(data);
      this.getAllOrganize(data);
      this.getGroupUser(data);
      this.getAllUser(data);

      let allField = data[3].data.map(a => {
        if (a.data) {
          a.data = a.data.map(b => ({ id: b, text: b }));
        }
        return { value: a.key, label: a.title, detail: a };
      });
      this.optionViews.allField = allField;
      this.optionViews.currentDatas.allField = allField;

      const statusList = [];
      data[0].data.forEach((c: any) => {
        statusList.push({
          label: c.name,
          value: c.id,
        });
      });
      this.optionViews.optionViews = [{ value: '-1', label: 'Chọn trạng thái' }, ...statusList];
      this.loadData();
    });
  }

  getAllUser(data) {
    const currentData = data[4].data.list;
    let allUser = currentData.map(a => ({
      value: a._id,
      label: a.name,
    }));
    this.optionViews.allUser = [{ value: '-1', label: 'Chọn chuyên viên' }, ...allUser];
    this.optionViews.currentDatas.allUser = currentData;
  }

  getGroupUser(data) {
    let groupUser = data[2].data.map(a => ({ value: a.id, label: a.name }));
    this.optionViews.groupUser = [{ value: '-1', label: 'Chọn bộ phận' }, ...groupUser];
    this.optionViews.currentDatas.groupUser = groupUser;
  }

  getAllOrganize(data) {
    let allOrganize = data[5].data.map(a => ({
      value: a.organize_id.toString(),
      label: a.name,
    }));
    this.optionViews.allOrganize = [{ value: '-1', label: 'Chọn tổ chức' }, ...allOrganize];
    this.optionViews.currentDatas.allOrganize = allOrganize;
  }

  getGroupEndUser(data) {
    let groupEndUser = data[1].data.map(a => ({
      value: a.id,
      label: a.name,
    }));
    this.optionViews.groupEndUser = [{ value: '-1', label: 'Chọn nhóm khách hàng' }, ...groupEndUser];
    this.optionViews.currentDatas.groupEndUser = groupEndUser;
  }

  ngAfterViewInit(): void {}

  initializeModelData() {
    const data = {
      data: {
        fields: [
          {
            fieldId: '',
            fieldValue: '',
          },
        ],
        dates: [
          {
            date: '',
            value: {
              from: '',
              to: '',
            },
          },
        ],
        organize_id: '-1',
        group_id: '-1',
        user_id: '-1',
        customerGroup_id: '-1',
        source_detail: '-1',
        status: '-1',
      },
      typeReport: 'excel',
      main_and_or: 'and',
      sub_and_or: 'and',
      name: '',
      type: 'report',
      type_filter: 'customize_report',
      _id: '',
    };

    if (this.user.role === Role.TeamLeader) {
      data.data.group_id = this.user.group_id;
    }
    this.ngModelData = data;
  }

  changedOptionView(data) {
    this.displayColumns = data;
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
  }

  async loadData(request: any = {}, sort: any = {}) {
    request.type = 'report';
    request.check_permission = true;
    const query = await this.buildBasePayload(request, sort);
    this.filterService.list(query).subscribe(res => {
      this.dataReportCustom = res.data.data.map((value, index) => {
        value.index = index + 1;
        let user = this.optionViews.currentDatas.allUser.find(a => a._id == value.user_id);
        value.created_at = moment(value.created_at).format('DD/MM/YYYY');
        value.report_type = 'Dạng Excel';
        value.created_by = user ? user.name : '';
        value.display_btn_action_status = this.user.email !== 'adminleader@newlandtravel.vn';
        return value;
      });
      this.initPage(res.data.total);
      this.isLoading = false;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {}

  onDateChange(key, value): void {
    this.loadData();
  }
  createNewReport() {
    this.displayType = this.displayTypes.Add;
    this.reNew();
    this.initializeModelData();
  }

  goBack() {
    this.displayType = this.displayTypes.View;
  }

  onSubmit(type) {
    if (!this.ngModelData.name || this.ngModelData.name.trim() === '') {
      this.toastr.error('Vui lòng nhập tên báo cáo');
      return;
    }

    this.ngModelData.name = this.ngModelData.name.trim();

    // validate dates
    let validateDates = false;
    this.ngModelData.data.dates.forEach(a => {
      if (a.date) {
        if (!a.value.from && !a.value.to) {
          validateDates = true;
        }
      }
    });
    if (validateDates) {
      this.toastr.error('Vui lòng nhập đầy đủ khung thời gian');
      return;
    }

    // validate fields
    let validateFields = {
      status: false,
      title: '',
    };
    this.ngModelData.data.fields.forEach(a => {
      if (a.fieldId) {
        if (!a.fieldValue || a.fieldValue.length == 0) {
          validateFields = {
            status: true,
            title: a.fieldDetail.title,
          };
        }

        if (a.fieldDetail.type == 'date') {
          if (!a.fieldValue.from && !a.fieldValue.to) {
            validateFields = {
              status: true,
              title: a.fieldDetail.title,
            };
          }
        }
      }
    });

    if (validateFields.status) {
      this.toastr.error('Vui lòng nhập đầy đủ trường thông tin ' + `"${validateFields.title}"`);
      return;
    }

    let payload = {
      data: {} as any,
      main_and_or: 'and',
      sub_and_or: 'and',
      name: this.ngModelData.name,
      type: 'report',
      type_filter: 'customize_report',
      is_assign_agent_id: this.ngModelData.data.user_id && this.ngModelData.data.user_id !== '-1',
      organize_id: this.ngModelData.data.organize_id,
      group_id: this.ngModelData.data.group_id,
    };

    if (this.ngModelData.data.status != '-1') {
      payload.data['status'] = [{ label: 'eq', val: this.ngModelData.data.status }];
    }
    if (this.ngModelData.data.customerGroup_id != '-1') {
      payload.data['customerGroup_id'] = this.ngModelData.data.customerGroup_id;
    }

    if (this.ngModelData.data.source_detail != '-1') {
      payload.data['source_detail'] = [{ label: 'eq', val: this.ngModelData.data.source_detail }];
    }

    if (
      (this.ngModelData.data.organize_id && this.ngModelData.data.organize_id != '-1') ||
      (this.ngModelData.data.group_id && this.ngModelData.data.group_id != '-1')
    ) {
      payload.data['assign_agent_id'] = this.optionViews.allUser
        .filter(a => a && a.val !== '-1')
        .map(value => ({ label: 'eq', val: value.value }));
    }

    if (this.ngModelData.data.user_id && this.ngModelData.data.user_id !== '-1') {
      payload.data['assign_agent_id'] = [{ label: 'eq', val: this.ngModelData.data.user_id }];
    }

    this.ngModelData.data.dates.forEach(a => {
      if (a.date) {
        payload.data[a.date] = [];
        if (a.value.from) {
          payload.data[a.date].push({ label: 'gte', val: a.value.from });
        }
        if (a.value.to) {
          payload.data[a.date].push({ label: 'lte', val: a.value.to });
        }
      }
    });

    this.ngModelData.data.fields.forEach(a => {
      if (a.fieldId) {
        payload.data[a.fieldId] = [];
        if (a.fieldValue) {
          if (a.fieldDetail.type == 'multi-select') {
            a.fieldValue.forEach(b => {
              payload.data[a.fieldId].push({ label: 'eq', val: b });
            });
          }

          if (a.fieldDetail.type == 'date') {
            if (a.fieldValue.from) {
              payload.data[a.fieldId].push({
                label: 'gte',
                val: a.fieldValue.from,
              });
            }
            if (a.fieldValue.to) {
              payload.data[a.fieldId].push({
                label: 'lte',
                val: a.fieldValue.to,
              });
            }
          }

          if (a.fieldDetail.type !== 'multi-select' && a.fieldDetail.type !== 'date') {
            payload.data[a.fieldId].push({ label: 'eq', val: a.fieldValue });
          }
        }
      }
    });

    payload.data = JSON.stringify(payload.data);

    if (type == 'edit') {
      const dataEditer = this.dataReportCustom.find(a => a._id === this.ngModelData._id);
      const userCreated = this.optionViews.currentDatas.allUser.find(a => a._id === dataEditer.user_id);
      if (this.user.role !== Role.TeamLeader && userCreated.role === Role.TeamLeader) {
        return this.toastr.error('Bạn không có quyền cập nhật báo cáo của trường bộ phận');
      }
      this.filterService.update(this.ngModelData._id, payload).subscribe(
        res => {
          if (res.status == '200' && !res.error) {
            this.toastr.success('Cập nhật thành công');
            this.displayType = this.displayTypes.View;
            this.reNew();
            this.loadData();
          }
        },
        error => {
          if (error.show) {
            this.toastr.error(error.message);
          } else {
            this.toastr.error('Có lỗi xảy ra khi cập nhật báo cáo');
          }
        }
      );
    }

    if (type == 'add') {
      this.filterService.create(payload).subscribe(
        res => {
          console.log(res, 'res');
          if (res.status == '200' && !res.error) {
            this.toastr.success('Tạo báo cáo thành công');
            this.displayType = this.displayTypes.View;
            this.reNew();
            this.loadData();
          }
        },
        error => {
          console.error('Error creating report:', error);
          if (error.show) {
            if (error.message && error.message.includes('bộ lọc')) {
              error.message = error.message.replace(/bộ lọc/g, 'báo cáo');
            }
            this.toastr.error(error.message);
          } else {
            this.toastr.error('Có lỗi xảy ra khi tạo báo cáo');
          }
        }
      );
    }
  }

  addNewDateItem() {
    this.ngModelData.data.dates.push({
      date: '',
      value: {
        from: '',
        to: '',
      },
    });
  }

  addNewFieldItem() {
    this.ngModelData.data.fields.push({
      fieldId: '',
      fieldValue: '',
    });
  }

  onFieldChange(index, event) {
    if (!event) {
      return;
    }
    const detail = this.optionViews.allField.find(a => a.value == event).detail;
    this.ngModelData.data.fields[index].fieldDetail = detail;

    if (detail.type == 'multi-select') {
      this.ngModelData.data.fields[index].fieldValue = [];
    }
    if (detail.type == 'date') {
      this.ngModelData.data.fields[index].fieldValue = {
        from: '',
        to: '',
      };
    }
  }
  valueChanged(event, index) {
    this.ngModelData.data.fields[index].fieldValue = event.value;
  }

  reNew() {
    this.initializeModelData();
  }

  getMaxDate(toDate: string): string {
    if (toDate) {
      const date = new Date(toDate);
      date.setDate(date.getDate() - 1); // Trừ một ngày từ toDate
      return date.toISOString().split('T')[0]; // Chuyển đổi thành chuỗi định dạng yyyy-mm-dd
    }
  }

  getMinDate(fromDate: string): string {
    if (fromDate) {
      const date = new Date(fromDate);
      date.setDate(date.getDate() + 1); // Cộng một ngày vào fromDate
      return date.toISOString().split('T')[0]; // Chuyển đổi thành chuỗi định dạng yyyy-mm-dd
    }
  }

  onOrganize_GroupChange() {
    let organize_id = this.ngModelData.data.organize_id;
    let group_id = this.ngModelData.data.group_id;

    if (this.ngModelData.data.organize_id == '-1') {
      organize_id = '';
    }

    if (this.ngModelData.data.group_id == '-1') {
      group_id = '';
    }

    if (organize_id && group_id) {
      this.optionViews.allUser = this.optionViews.currentDatas.allUser.filter(
        a => a.organize_id == organize_id && a.group_id == group_id
      );
    }

    if (!organize_id && group_id) {
      this.optionViews.allUser = this.optionViews.currentDatas.allUser.filter(a => a.group_id == group_id);
    }

    if (organize_id && !group_id) {
      this.optionViews.allUser = this.optionViews.currentDatas.allUser.filter(a => a.organize_id == organize_id);
    }

    if (!organize_id && !group_id) {
      this.optionViews.allUser = this.optionViews.currentDatas.allUser;
    }

    this.optionViews.allUser = [
      { value: '-1', label: 'Chọn chuyên viên' },
      ...this.optionViews.allUser.map(a => ({ value: a._id, label: a.name })),
    ];
  }

  handleCustomAction(event) {
    if (event.type == 'export') {
      this.handleExportTicket(event.item);
    }
  }

  handleExportTicket(item) {
    let data = typeof item.data === 'string' ? JSON.parse(item.data) : item.data;

    if (!item.is_assign_agent_id && (item.group_id || item.organize_id)) {
      data.assign_agent_id = this.optionViews.currentDatas.allUser
        .filter(
          e =>
            (item.group_id && item.organize_id && item.group_id === e.group_id && item.organize_id === e.organize_id) ||
            (item.group_id && item.group_id === e.group_id) ||
            (item.organize_id && item.organize_id === e.organize_id)
        )
        .map(a => ({
          label: 'eq',
          val: a._id,
        }));
    }

    const params = {
      source: 'all',
    };
    let condition: any = { must: [] };

    Object.keys(data)
      .filter(key => key !== 'customerGroup_id')
      .forEach(key => {
        let object: any = {
          bool: {},
        };
        switch (key) {
          case 'assign_agent_id':
            object.bool.should = data[key].map(e => ({
              match_phrase: { [key]: e.val },
            }));
            break;
          case 'time_start':
          case 'time_end':
          case 'created_at':
          case 'updated_at':
          case 'thoidiem':
            object.bool.must = data[key].map(e => ({
              range: {
                [key]: {
                  [e.label]: e.val,
                },
              },
            }));
            break;

          default:
            object.bool.must = data[key].map(e => ({
              match_phrase: { [key]: e.val },
            }));

            break;
        }

        condition.must.push(object);
      });

    let dataCustomerByGroup = [];

    if (data.hasOwnProperty('customerGroup_id') && data.customerGroup_id) {
      let payload: any = {
        active_fields: JSON.stringify(['group_id']),
        force_search: 'customer',
        label: 'and',
        sub_label: 'and',
        type: 'user',
        condition: {
          must: [
            {
              bool: {
                must: [
                  {
                    match_phrase: {
                      group_id: data.customerGroup_id.toString(),
                    },
                  },
                ],
              },
            },
          ],
        },
      };

      payload.condition = JSON.stringify(payload.condition);
      this.searchService.all(payload).subscribe(res => {
        dataCustomerByGroup = res.data.list;

        if (dataCustomerByGroup.length > 0) {
          let object: any = {
            bool: {
              should: [],
            },
          };
          dataCustomerByGroup.map(e => {
            object.bool.should.push({
              match_phrase: {
                requester_id: e._id,
              },
            });
          });
          condition.must.push(object);
        }

        const body = {
          condition: JSON.stringify(condition),
          active_fields: JSON.stringify(['assign_agent_id']),
          type: 'ticket',
          label: 'and',
          sub_label: 'and',
          keyword: '',
          force_search: 'customer',
        };

        this.ticketService.exports(params, body);
      });
    } else {
      const body = {
        condition: JSON.stringify(condition),
        active_fields: JSON.stringify(['assign_agent_id']),
        type: 'ticket',
        label: 'and',
        sub_label: 'and',
        keyword: '',
        force_search: 'customer',
      };

      this.ticketService.exports(params, body);
    }
  }

  handleTableAction(event) {
    if (event.type === 'delete') {
      if (confirm('Bạn có chắc chắn muốn xóa báo cáo này?')) {
        this.filterService._delete(event.item._id).subscribe(
          res => {
            console.log(res, 'res');
            this.loadData();
            this.toastr.success('Xóa báo cáo thành công');
          },
          error => {
            console.error('Error deleting report:', error);
            this.toastr.error('Có lỗi xảy ra khi xóa báo cáo');
          }
        );
      }
    }
  }

  handleClickEditer(key, item) {
    this.displayType = this.displayTypes.Edit;
    if (typeof item.data === 'string') {
      item.data = JSON.parse(item.data);
    }

    let formatData = {
      data: {
        organize_id: item.organize_id || '-1',
        group_id: item.group_id || '-1',
        user_id:
          (item.is_assign_agent_id && item.data.assign_agent_id && item.data.assign_agent_id[0].val) || '-1' || '-1',
        customerGroup_id: item.data.customerGroup_id ? item.data.customerGroup_id : '-1',
        source_detail: (item.data.source_detail && item.data.source_detail[0].val) || '-1',
        status: (item.data.status && item.data.status[0].val) || '-1',
      } as any,
      typeReport: 'excel',
      main_and_or: 'and',
      sub_and_or: 'and',
      name: item.name,
      type: 'report',
      type_filter: 'customize_report',
      _id: item._id,
    };

    let dates = [];
    let fields = [];
    // Map through the item object

    console.log(item.data, 'item.data');
    Object.keys(item.data).forEach(key => {
      if (this.optionViews.typeTimeOption.find(value => value.value == key)) {
        let data = {};
        item.data[key].map(a => {
          let key = a.label == 'gte' ? 'from' : 'to';
          data[key] = a.val;
        });
        dates.push({
          date: key,
          value: data,
        });
      }

      let isfield = this.optionViews.currentDatas.allField.find(a => a.value == key);
      if (isfield) {
        let data: any = {
          fieldDetail: isfield.detail,
          fieldId: key,
        };
        if (isfield.detail.type == 'multi-select') {
          data.fieldValue = item.data[key].map(a => a.val);
        }

        if (isfield.detail.type == 'date') {
          let dataDate = {};
          item.data[key].map(a => {
            let key = a.label == 'gte' ? 'from' : 'to';
            dataDate[key] = a.val;
          });
          data.fieldValue = dataDate;
        }

        if (isfield.detail.type !== 'multi-select' && isfield.detail.type !== 'date') {
          data.fieldValue = item.data[key][0].val;
        }
        fields.push(data);
      }
    });

    formatData.data.dates = dates;
    formatData.data.fields = fields;
    // Assign the formatted data back to ngModelData
    this.ngModelData = formatData;

    this.onOrganize_GroupChange();
  }

  removeItem(index, type) {
    if (type == 'dates') {
      this.ngModelData.data.dates = this.ngModelData.data.dates.filter((_, i) => i !== index);
    }
    if (type == 'fields') {
      this.ngModelData.data.fields = this.ngModelData.data.fields.filter((_, i) => i !== index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/custom/custom.component.ts